import React from 'react';
import SpecLink from 'src/components/SpecLink';

function TxnTokenFlow(integrationName) {
    return (<>        
            <h2 id="TokenFlow">Token flow</h2>
            <p>
                The token flow allows you to apply a tokenised card to a payment.
            </p>
            <p><b>Please note, as a developer, it is your responsibility to determine if you are applying the correct tokenised 
                    card details to a customer.  BPoint will not be responsible for merchants applying tokenised payments 
                    to incorrect customers.</b></p>
            <p>
                To apply a payment via a tokenised card, you will need to call <SpecLink uriFragment="#operation/TxnAuthkey_AttachPaymentMethod">Attach payment method and pass in the Token number</SpecLink>.  The endpoint 
                will return the masked bank account or masked credit card details.
            </p>
            <p>
                These details can be presented to the customer to verify their payment details before completing the payment.  Please note, you should allow the customer to modify the credit card expiry 
                if it has changed, to successfully complete the payment.
            </p>
            <p>
                Once <SpecLink uriFragment="#operation/TxnAuthkey_AttachPaymentMethod">Attach payment method with Token number</SpecLink> is successful, you may continue to process the payment via {integrationName} integration method.
            </p>
        </>);
}

export default TxnTokenFlow;